import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import { useHistory } from 'react-router-dom';

import { iRootState, iRootDispatch } from '../../store';
import { getAllDashboards, getDashboard } from '../../services/dashboard';
import {
  Container,
  CardWrapper,
  WelcomeTitle,
  WelcomeSubtitle,
  InfoBanner,
  AppLabel,
  AppsContainer,
  AppCard,
  IconRight
} from './styles';
import Card from './components/Card';
import { HeaderWrapper, ButtonsWrapper, BannersWrapper } from './styles';

import RedeVistoriasIMG from '../../resources/imgs/redevistorias.svg';
import RedeIzeeIMG from '../../resources/imgs/redeizee.svg';

import { CurrentPageState } from '../../store/types/temp-types';
import { PushRoute } from '../../util';
import AuthorizationContainer from '../../components/AuthorizationContainer';
import { ActionEnum } from '../../enums/authz-action.enum';
import { FeatureEnum } from '../../enums/authz-feature.enum';
import { dangerNotification } from '../../services/notification';
import useWindowSize from '../../hooks/useWindowSize';
import CustomBanner from './components/CustomBanner';
import { useQuery } from '@tanstack/react-query';
import { getBanners } from '../../services/banner';
import { BannerLocationActivationEnum, BannerStatusEnum } from '../../types/Banner';
import { UserRolesEnum } from '../../enums/user-roles.enum';
import { get } from '../../services/storage';
import { UpdateEstateDataModal } from '../../components/UpdateEstateDataModal';
import { Icon, Modal } from 'semantic-ui-react';
import HolidayNoticeModal from './components/HolidayNoticeModal';
import PwaInstallBanner from '../../components/PwaInstallBanner';
import PopupModal from '../../components/PopupModal';
import EstateUnitFilter from '../../components/EstateUnitFilter';

const iframeBaseUrl =
  'https://forms.office.com/Pages/ResponsePage.aspx?id=7SXP5Wfkb0msuWMCdPEtNPw516KlkcpLidzd4F2_85VUM0VEWFRFN1lNMTQwM05ERU02MkUwSzdMMC4u&embed=true&ra0f0a6e05efe4b4cb79a903bb666b926=';

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

const TITLE_FORM_SURVEY = 'Pesquisa de Satisfação - Lado Bom Seguros';

const shouldOpenModal = (key: string): boolean => {
  const now = Date.now();
  const stored = localStorage.getItem(key);

  if (!stored) return true;

  try {
    const { expiry } = JSON.parse(stored);
    if (now > expiry) return true;
    return false;
  } catch {
    return true;
  }
};

const setExpiryInLocalStorage = (key: string, expiryMs: number = SEVEN_DAYS_MS) => {
  const expiry = Date.now() + expiryMs;
  localStorage.setItem(key, JSON.stringify({ expiry }));
};

const mapState = (state: iRootState) => {
  return {
    user: state.user,
    availableBrokersAndEstates: state.availableBrokersAndEstates
  };
};

enum FilterEnum {
  bondInsurancesTotal = 'biTotal',
  bondInsurancesApproveds = 'biApproveds',
  bondInsurancePolicyCreated = 'biPolicyCreated',
  bondInsuranceHired = 'biHired',
  bondInsuranceWaiting = 'biWaiting',
  bondInsuranceToExpire = 'biToExpire',
  policyToExpire = 'policyToExpire',
  fireInsurancesTotal = 'fiTotal',
  fireInsurancesPendentPayment = 'fiPendentPayment',
  fireInsurancesToExpire = 'fiToExpire',
  fireInsurancesPolicyToExpire = 'fiPolicyToExpire',
  fireInsurancesPolicyWaiting = 'fiPolicyWaiting',
  fireInsurancesPolicyHired = 'fiPolicyHired',
  capitalizationsInProgress = 'capitalizationsInProgress',
  capitalizationsWaitingPayment = 'capitalizationsWaitingPayment',
  capitalizationsHired = 'capitalizationsHired'
}

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateCurrentPage: (state: CurrentPageState) =>
    dispatch.currentPage.updateCurrentPage(state)
});

const RealDashboard = (props: any) => {
  const { user } = props;
  const history = useHistory();
  const activeEstateId =
    props.availableBrokersAndEstates?.activeEstateId ||
    user?.activeEstateId ||
    user?.estate?.id;
  const [estate, setEstate] = useState<any>();
  const [biTotal, setBiTotal] = useState<number>();
  const [biApproveds, setBiApproveds] = useState<number>();
  const [biPolicyCreated, setBiPolicyCreated] = useState<number>();
  const [biHired, setBiHired] = useState<number>();
  const [biWaiting, setBiWaiting] = useState<number>();
  const [biToExpire, setBiToExpire] = useState<number>();
  const [capitalizationsInProgress, setCapitalizationsInProgress] = useState<number>();
  const [capitalizationsHired, setCapitalizationsHired] = useState<number>();
  const [capitalizationsWaitingPayment, setCapitalizationsWaitingPayment] =
    useState<number>();
  const [policyToExpire, setPolicyToExpire] = useState<number>(0);
  const [fiTotal, setFiTotal] = useState<number>(0);
  const [fiPendentPayment, setFiPendentPayment] = useState<number>(0);
  const [fiToExpire, setFiToExpire] = useState<number>(0);
  const [fiPolicyHired, setFiPolicyHired] = useState<number>(0);
  const [fiPolicyWaiting, setFiPolicyWaiting] = useState<number>(0);
  const [fiPolicyToExpire, setFiPolicyToExpire] = useState<number>(0);
  const [openSearchModal, setOpenSearchModal] = useState<boolean>(false);
  const [emailEncoded, setEmailEncoded] = useState<string>('');
  const [openHolidayNoticeModal, setOpenHolidayNoticeModal] = useState<boolean>(false);
  const [estateUnitIdFilter, setEstateUnitIdFilter] = useState('');

  const { isMobile } = useWindowSize();

  const dashboardParams = estateUnitIdFilter ? { estateUnitId: estateUnitIdFilter } : undefined;

  const fetchData = async (filter: string) => {
    try {
      let response;
      if (props.user.role.includes('ESTATE')) {
        response = await getDashboard(activeEstateId, filter, dashboardParams);
      } else {
        response = await getAllDashboards(filter, dashboardParams);
      }
      switch (filter) {
        case FilterEnum.bondInsurancesTotal:
          setBiTotal(response);
          break;
        case FilterEnum.bondInsurancesApproveds:
          setBiApproveds(response);
          break;
        case FilterEnum.bondInsurancePolicyCreated:
          setBiPolicyCreated(response);
          break;
        case FilterEnum.bondInsuranceHired:
          setBiHired(response);
          break;
        case FilterEnum.bondInsuranceToExpire:
          setBiToExpire(response);
          break;
        case FilterEnum.bondInsuranceWaiting:
          setBiWaiting(response);
          break;
        case FilterEnum.policyToExpire:
          setPolicyToExpire(response);
          break;
        case FilterEnum.capitalizationsHired:
          setCapitalizationsHired(response);
          break;
        case FilterEnum.capitalizationsInProgress:
          setCapitalizationsInProgress(response);
          break;
        case FilterEnum.capitalizationsWaitingPayment:
          setCapitalizationsWaitingPayment(response);
          break;
        // case FilterEnum.fireInsurancesTotal:
        //   setFiTotal(response);
        //   break;
        // case FilterEnum.fireInsurancesPendentPayment:
        //   setFiPendentPayment(response);
        //   break;
        // case FilterEnum.fireInsurancesPolicyToExpire:
        //   setFiPolicyToExpire(response);
        //   break;
        // case FilterEnum.fireInsurancesPolicyHired:
        //   setFiPolicyHired(response);
        //   break;
        // case FilterEnum.fireInsurancesToExpire:
        //   setFiToExpire(response);
        //   break;
        // case FilterEnum.fireInsurancesPolicyWaiting:
        //   setFiPolicyWaiting(response);
        //   break;
        default:
          break;
      }
    } catch (err) {
      console.log('ERROW', err);
      dangerNotification(
        'Oops...',
        'Não foi possível buscar os dados do Dashboard, tente novamente mais tarde.'
      );
    }
  };

  useEffect(() => {
    fetchData(FilterEnum.bondInsurancesTotal);
    fetchData(FilterEnum.bondInsurancesApproveds);
    fetchData(FilterEnum.bondInsurancePolicyCreated);
    fetchData(FilterEnum.bondInsuranceHired);
    fetchData(FilterEnum.bondInsuranceWaiting);
    fetchData(FilterEnum.bondInsuranceToExpire);
    fetchData(FilterEnum.policyToExpire);
    fetchData(FilterEnum.capitalizationsInProgress);
    fetchData(FilterEnum.capitalizationsHired);
    fetchData(FilterEnum.capitalizationsWaitingPayment);
  }, [activeEstateId, estateUnitIdFilter]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesTotal);
  // }, [fiTotal]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesPendentPayment);
  // }, [fiPendentPayment]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesPolicyToExpire);
  // }, [fiPolicyToExpire]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesPolicyHired);
  // }, [fiPolicyHired]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesPolicyWaiting);
  // }, [fiPolicyWaiting]);

  // useEffect(() => {
  //   fetchData(FilterEnum.fireInsurancesToExpire);
  // }, [fiToExpire]);

  const userToken = get('id_token');
  const isRV = process.env.REACT_APP_IS_RV === 'true';
  const isDevelop =
    process.env.REACT_APP_IS_DEVELOP === 'true' ||
    window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
    window.location.hostname === 'localhost';

  const redeOptions = [
    {
      link: !isDevelop
        ? `${process.env.REACT_APP_PAINEL_RV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`
        : `${process.env.REACT_APP_PAINEL_RV_DEV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`
    },
    {
      link: !isDevelop
        ? `${process.env.REACT_APP_REDE_IZEE_URL}/auth#access_token=${userToken}&token_type=Bearer&expires_in=86400`
        : `${process.env.REACT_APP_REDE_IZEE_DEV_URL}/auth#access_token=${userToken}&token_type=Bearer&expires_in=86400`
    }
  ];

  const { data: banners, isFetching: isBannersLoading } = useQuery(
    ['getBanners', ''],
    () => getBanners(BannerStatusEnum.ACTIVE),
    {
      keepPreviousData: true
    }
  );

  useEffect(() => {
    const data = get('estate');
    if (data) {
      setEstate(JSON.parse(data));
    }
  }, []);

  const handleOpenSearchModal = () => {
    setOpenSearchModal(true);
  };

  const handleCloseSearchModal = () => {
    setOpenSearchModal(false);
  };

  const handleOpenHolidayNoticeModal = () => {
    setOpenHolidayNoticeModal(true);
  };

  useEffect(() => {
    if (!user?.email || !user?.id) return;
    const disableDate = new Date('2025-12-31T23:59:59');
    if (new Date() > disableDate) {
      return;
    }
    const storageNoticeKey = `holidayNotice_${user.id}`;

    if (shouldOpenModal(storageNoticeKey)) {
      const expiryIn2days = 48 * 60 * 60 * 1000;
      setExpiryInLocalStorage(storageNoticeKey, expiryIn2days);
      handleOpenHolidayNoticeModal();
    }
  }, [user]);

  return (
    <Container>
      {estate && (
        <UpdateEstateDataModal
          estateName={estate.name}
          estateMainEmail={estate.email}
          estateFinancialEmail={estate.financialEmail}
          notificationEmailList={estate.notificationEmails}
          estateResponsibleEmail={estate.responsibleEmail}
          estateId={estate.id}
        />
      )}

      {/* PWA Install Banner for mobile users */}
      <PwaInstallBanner />

      {props.user.role.includes('ESTATE') && (
        <div style={{ maxWidth: 320, marginBottom: 16 }}>
          <EstateUnitFilter
            estateId={String(activeEstateId || '')}
            value={estateUnitIdFilter}
            onChange={setEstateUnitIdFilter}
          />
        </div>
      )}

      {!isMobile && (
        <BannersWrapper>
          <InfoBanner>
            <WelcomeTitle>
              Bem vindo à sua <br />
              <b>Dashboard</b>
            </WelcomeTitle>
            <WelcomeSubtitle>
              Aqui você poderá encontrar informações gerenciais e navegar em nossos outros
              produtos e agregar ainda mais para seu negócio.
            </WelcomeSubtitle>
            <ButtonsWrapper>
              <Button
                size={'tiny'}
                onClick={() => PushRoute(history, props, 'bond-insurance')}
              >
                Nova Análise
              </Button>
              <Button
                light
                size={'tiny'}
                onClick={() => {
                  PushRoute(history, props, 'bond-insurances');
                }}
              >
                Gerenciar
              </Button>
            </ButtonsWrapper>
            {isRV && (
              <>
                <AppLabel>
                  Otimize seus processo - Conheça os outros serviços do Grupo RV!
                </AppLabel>
                <AppsContainer>
                  <AppCard
                    href={redeOptions[0].link}
                    title="Rede Vistorias"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img width={70} height={40} src={RedeVistoriasIMG} />
                    <span>Realize e acompanhe pedidos de vistorias</span>
                    <IconRight name="arrow right" color="grey" />
                  </AppCard>
                  <AppCard
                    href={redeOptions[1].link}
                    title="Rede Izee"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img width={70} height={40} src={RedeIzeeIMG} />
                    <span>Gerencie contratos e analise sua carteira de imóveis.</span>
                    <IconRight name="arrow right" color="grey" />
                  </AppCard>
                </AppsContainer>
              </>
            )}
          </InfoBanner>
          <CustomBanner banners={banners} isLoading={isBannersLoading} />
        </BannersWrapper>
      )}

      <AuthorizationContainer action={ActionEnum.read} feature={FeatureEnum.analysis}>
        <div style={{ flex: 1, minWidth: 320 }}>
          <HeaderWrapper>
            <h2>Seguros Fiança</h2>

            {/* <ButtonsWrapper>
              <Button
                basic
                color={'blue'}
                size={'tiny'}
                onClick={() => {
                  PushRoute(history, props, 'bond-insurances');
                }}
              >
                Gerenciar
              </Button>

              <Button
                primary
                size={'tiny'}
                onClick={() => PushRoute(history, props, 'bond-insurance')}
              >
                Nova Análise
              </Button>
            </ButtonsWrapper> */}
          </HeaderWrapper>

          <CardWrapper>
            <Card
              label={'Aprovados'}
              quantity={biApproveds}
              isLoading={biApproveds === undefined}
              {...(biApproveds && biApproveds > 0
                ? {
                    onClick: () =>
                      PushRoute(history, props, 'bond-insurances', {
                        analysisStatus: 'APPROVED'
                      })
                  }
                : '')}
            />
            {user.role === UserRolesEnum.brokerAdmin && (
              <Card
                label={'Contratações em andamento'}
                quantity={biHired}
                isLoading={biHired === undefined}
              />
            )}

            <Card
              label={'Aprovações a expirar em 07 dias'}
              quantity={biToExpire || 0}
              isLoading={biToExpire === undefined}
              {...(biToExpire && biToExpire > 0
                ? {
                    onClick: () =>
                      PushRoute(history, props, 'bond-insurances', {
                        expiresInAWeek: true
                      })
                  }
                : '')}
              isNegative={!!(biToExpire && biToExpire > 0)}
            />

            {user.role === UserRolesEnum.brokerAdmin && (
              <Card
                label={'Cadastrados'}
                quantity={biTotal}
                isLoading={biTotal === undefined}
              />
            )}

            {user.role === UserRolesEnum.brokerAdmin && (
              <Card
                label={'Aguardando emissão'}
                quantity={biWaiting || 0}
                isLoading={biWaiting === undefined}
              />
            )}

            <Card
              label={'Emitidos'}
              quantity={biPolicyCreated || 0}
              isLoading={biPolicyCreated === undefined}
            />
            {/* <Card
              label={'Apólices expiram nos próximos 30 dias'}
              quantity={policyToExpire || 0}
              isLoading={policyToExpire === undefined}
              {...(policyToExpire && policyToExpire > 0
                ? {
                    onClick: () =>
                      PushRoute(history, props, 'bond-insurance-policies', {
                        expireInDays: '30'
                      })
                  }
                : '')}
            /> */}
          </CardWrapper>
        </div>
      </AuthorizationContainer>

      {isDevelop && (
        <AuthorizationContainer
          action={ActionEnum.read}
          feature={FeatureEnum.fireinsurances}
        >
          <div style={{ flex: 1, minWidth: 320 }}>
            <HeaderWrapper>
              <h2>Incêndio</h2>

              {/* <ButtonsWrapper>
              <Button
                basic
                color={'blue'}
                size={'tiny'}
                onClick={() => PushRoute(history, props, 'fire-insurance-policies')}
              >
                Gerenciar
              </Button>
            </ButtonsWrapper> */}
            </HeaderWrapper>
            <CardWrapper>
              <Card
                label={'Orçados'}
                quantity={fiTotal || 0}
                isLoading={fiTotal === undefined}
              />

              <Card
                label={'Pagamentos pendentes'}
                quantity={fiPendentPayment || 0}
                isLoading={fiPendentPayment === undefined}
                isNegative={!!(fiPendentPayment && fiPendentPayment > 0)}
              />

              <Card
                label={'Orçados a expirar em 07 dias'}
                quantity={fiToExpire || 0}
                isLoading={fiToExpire === undefined}
              />

              <Card
                label={'Apólices emitidas'}
                quantity={fiPolicyHired || 0}
                isLoading={fiPolicyHired === undefined}
              />

              {user.role === UserRolesEnum.brokerAdmin && (
                <Card
                  label={'Apólices em espera'}
                  quantity={fiPolicyWaiting || 0}
                  isLoading={fiPolicyWaiting === undefined}
                />
              )}

              <Card
                label={'Apólices a expirar'}
                quantity={fiPolicyToExpire || 0}
                isLoading={fiPolicyToExpire === undefined}
              />
            </CardWrapper>{' '}
          </div>
        </AuthorizationContainer>
      )}

      <AuthorizationContainer action={ActionEnum.read} feature={FeatureEnum.claims}>
        <div style={{ flex: 1, minWidth: 320 }}>
          <HeaderWrapper>
            <h2>Capitalizações</h2>

            {/* <ButtonsWrapper>
              <Button
                basic
                color={'blue'}
                size={'tiny'}
                onClick={() => PushRoute(history, props, 'claim_estates')}
              >
                Gerenciar
              </Button>
            </ButtonsWrapper> */}
          </HeaderWrapper>
          <CardWrapper>
            <Card
              label={'Em emissão'}
              quantity={capitalizationsInProgress || 0}
              isLoading={capitalizationsInProgress === undefined}
            />

            <Card
              label={'Aguardando pagamento'}
              quantity={capitalizationsWaitingPayment || 0}
              isLoading={capitalizationsWaitingPayment === undefined}
            />

            <Card
              label={'Emitido'}
              quantity={capitalizationsHired || 0}
              isLoading={capitalizationsHired === undefined}
            />
          </CardWrapper>
        </div>
      </AuthorizationContainer>

      <Modal
        open={openSearchModal}
        onClose={handleCloseSearchModal}
        size="small"
        closeOnEscape={false}
        closeOnTriggerClick={false}
        closeOnDocumentClick={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0.75rem 1rem'
          }}
        >
          <span>{TITLE_FORM_SURVEY}</span>
          <Button
            icon
            circular
            onClick={handleCloseSearchModal}
            style={{ float: 'right', cursor: 'pointer' }}
          >
            <Icon name="close" />
          </Button>
        </Modal.Header>
        <Modal.Content style={{ padding: '0.25rem' }}>
          <div>
            <iframe
              width="740px"
              height="480px"
              title={TITLE_FORM_SURVEY}
              style={{ border: 'none', maxWidth: '100%', maxHeight: '100vh' }}
              src={`${iframeBaseUrl}${emailEncoded}`}
              frameBorder="0"
              marginWidth={0}
              marginHeight={0}
              allowFullScreen
            />
          </div>
        </Modal.Content>
      </Modal>

      <HolidayNoticeModal
        open={openHolidayNoticeModal}
        onClose={() => setOpenHolidayNoticeModal(false)}
      />

      <PopupModal locationActivation={BannerLocationActivationEnum.HOME_PAGE} />
    </Container>
  );
};

export default connect(mapState, mapDispatch)(RealDashboard);
